import { useEffect, useState } from 'react';

function isCompactViewport(): boolean {
    return window.innerWidth <= 800 || (window.innerHeight <= 500 && window.innerWidth > window.innerHeight);
}

export function useCompactViewport(): boolean {
    const [compact, setCompact] = useState(isCompactViewport);
    useEffect(() => {
        const update = () => setCompact(isCompactViewport());
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);
    return compact;
}
